import { Injectable } from '@angular/core';
import { v4 } from 'uuid';
import { MAP_ZOOM_LIMITS } from '../constants/map-zoom.constants';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  static deviceAndBrowserUuid = {
    randomUUID: v4(),
  };

  smallDialogConfig = {
    panelClass: ['fr8bot-dialog-small'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  referenceDialogConfig = {
    width: '100%',
    maxWidth: '520px',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'base-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  confirmationDialogConfig = {
    ...this.referenceDialogConfig,
  };

  secondDialogConfig = {
    maxWidth: '100%',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'second-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  servicePageConfig = {
    maxWidth: '100%',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common'],
    closeOnNavigation: false,
    hasBackdrop: false,
  };

  fullScreenDialogConfig = {
    maxWidth: '100%',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  fullScreenDialogWithoutCloseConfig = {
    maxWidth: '100%',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: false,
    hasBackdrop: true,
    disableClose: true,
  };

  loadDetailsDialogConfig = {
    maxWidth: '100dvw',
    maxHeight: '100dvh',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  memberDialogConfig = {
    width: '100%',
    maxWidth: '900px',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  addDirectCustomerDialogConfig = {
    width: '100%',
    maxWidth: '710px',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  notificationCenterDialogConfig = {
    width: '100%',
    maxWidth: '410px',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
    position: { right: '0', top: '0' },
  };

  /** An entity picker; it covers the whole screen from the small dialog's 744px breakpoint down. */
  entityPickerDialogConfig = {
    panelClass: [
      'mat-dialog-common',
      'full-screen-dialog-container',
      'fr8bot-dialog-full-screen-mobile',
    ],
    minHeight: '90vh',
    minWidth: '90vw',
    maxHeight: '90vh',
    maxWidth: '90vw',
    closeOnNavigation: true,
    hasBackdrop: true,
  };

  chatDialogConfig = {
    width: '100%',
    maxWidth: '500px',
    maxHeight: '100%',
    panelClass: ['mat-dialog-common', 'full-screen-dialog-container'],
    closeOnNavigation: true,
    hasBackdrop: true,
    position: { right: '0', top: '0' },
  };

  /** Angular X Image Viewer Config */
  contentViewerDialog = {
    closeOnNavigation: true,
    disableClose: true,
    hasBackdrop: false,
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: '100%',
    panelClass: ['standard-dialog', 'content-viewer'],
  };

  static PASSWORD_SPECIAL_CHARACTER_REGEX: RegExp = /[^A-Za-z0-9]/;
  static PASSWORD_NUMBER_REGEX: RegExp = /\d/;

  static TEXT_SEARCH_DELAY: number = 600;

  googleMapOptions: google.maps.MapOptions = {
    center: {
      lat: 39.5,
      lng: -98.35,
    },
    zoom: 4,
    ...MAP_ZOOM_LIMITS,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    colorScheme: 'DARK',
    mapId: 'cc301cb1bb42e7d1baffb562',
    clickableIcons: false,
    renderingType: 'VECTOR',
  };

  googleMapOptionsAdvanced = {
    ...this.googleMapOptions,
    disableDefaultUI: true,
  };

  /** Google map-polyline */

  getPolylineOptions(color?: string) {
    return {
      ...this.polylineOptions,
      ...(color && { strokeColor: color }),
    };
  }

  polylineOptions: google.maps.PolylineOptions = {
    strokeOpacity: 1,
    strokeWeight: 4,
    zIndex: 8,
  };
}
